<template>
  <div style="height: 100%">
    <w-modal
      title="患者360视图"
      :visible.sync="dialogVisible"
      width="100%"
      class="pdf-model"
      :before-close="clickBack"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <iframe
        :src="this.patientUrl"
        frameborder="0"
        style="width: 100%; height: 92vh"
      ></iframe>
    </w-modal>
  </div>
</template>

<script>
export default {
  name: 'Patient360',
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    patientUrl: {
      type: String,
      default: ''
    },
    clickBack: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      url: ''
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.pdf-model {
  /deep/ .w-modal {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>
